// 위임 폼 문맥 노출(progressive disclosure) 컨트롤러 — 연결된 스코프/권한 체크박스가 켜질 때만 제약(한도) 패널을 노출한다.
// 역할: data-reveal-key 를 가진 체크박스의 체크 여부를 모아, 같은 key 를 가진 panel 타깃만 표시하고 나머지는 숨긴다.
// CAUTION: panel 과 체크박스는 반드시 같은 data-controller="reveal" 요소의 자손이어야 스코프가 맞는다.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  // 초기 진입 시 현재 체크 상태 기준으로 패널 표시/숨김을 1회 맞춘다(플래시 방지 초기 display:none 과 짝).
  connect() { this.sync() }

  // 체크된 key 집합을 만들고, panel 의 data-reveal-key 가 그 집합에 있으면 노출("")·없으면 숨김("none").
  sync() {
    const checked = new Set(
      Array.from(this.element.querySelectorAll("input[type=checkbox][data-reveal-key]"))
        .filter((cb) => cb.checked).map((cb) => cb.dataset.revealKey)
    )
    this.panelTargets.forEach((p) => { p.style.display = checked.has(p.dataset.revealKey) ? "" : "none" })
  }
}
